import { Injectable } from '@angular/core';
import { LeavePageService } from '@app/core/leave-page-handler/service/leave-page.service';
import { RedirectService } from '@app/core/services/redirect.service';
import { UserService } from '@app/core/services/user.service';
import * as AcceptanceGtcActions from '@app/pcs/administration/acceptance-gtc/actions/acceptance-gtc';
import { PapSearchType } from '@app/pcs/models/pap-search-type';
import { UserActionTypes } from '@app/pcs/user/actions/user';
import { CHANGE_PASS_PATH, CHANGE_PASSWORD, GDPR, GDPR_PATH } from '@app/pcs/user/constants';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATION, RouterNavigationAction } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { mapPayload } from '@util';
import { switchMap, tap } from 'rxjs/operators';

@Injectable()
export class PcsRedirectEffects {

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private leavePageService: LeavePageService,
    private redirectService: RedirectService,
    private store: Store<any>
  ) {
  }

  routerNavigation$ = createEffect(() => this.actions$.pipe(
    ofType(ROUTER_NAVIGATION),
    tap((action: RouterNavigationAction) => {
      if (this.userService.getUser()) {
        const routerState = action.payload;
        const loginRedirectTo: string = this.userService.getUser().loginRedirectTo;

        if (this.isRedirectRequired(loginRedirectTo, routerState, GDPR, GDPR_PATH)) {
          this.redirectService.goToGDPR();
        } else if (this.isRedirectRequired(loginRedirectTo, routerState, CHANGE_PASSWORD, CHANGE_PASS_PATH)) {
          this.redirectService.goToChangePassword();
        }
      }
    })
  ), {dispatch: false});

  redirectUserToHomePage$ = createEffect(() => this.actions$.pipe(
    ofType(UserActionTypes.UserRedirectToHomePage),
    switchMap(() => this.leavePageService.check().pipe(
      tap((canRedirect) => {
        if (canRedirect) {
          this.redirectService.goToHome();
        }
      })
    ))
  ), {dispatch: false});

  goBack$ = createEffect(() => this.actions$.pipe(
    ofType(UserActionTypes.UserGoBack),
    switchMap(() => this.leavePageService.check().pipe(
      tap((canRedirect) => {
        if (canRedirect) {
          this.redirectService.goBack();
        }
      })
    ))
  ), {dispatch: false});

  goToGtc$ = createEffect(() => this.actions$.pipe(
    ofType(UserActionTypes.UserGoToGtc),
    mapPayload(),
    tap((ttpId: number) => {
      this.redirectService.goToGtcAcceptance().then(() =>
        this.store.dispatch(new AcceptanceGtcActions.SelectTtpId(ttpId)));
    }
    )), {dispatch: false});

  userToGoPaPSearch$ = createEffect(() => this.actions$.pipe(
    ofType(UserActionTypes.UserToGoPaPSearch),
    mapPayload(),
    tap(() => {
      this.redirectService.goToPapSearch({
        searchType: PapSearchType.Default
      });
    })), {dispatch: false});

  private isRedirectRequired(loginRedirectTo, routerState, redirectionOption, redirectionPath) {
    return loginRedirectTo === redirectionOption && routerState.event.url !== redirectionPath;
  }
}
